/**
 * Scheduling search constants — FE-specific defaults and labels.
 * Time block definitions are imported from @vagusx/shared (shared with BE).
 */

/** Default number of days ahead when opening the slot search form */
export const DEFAULT_DAYS_AHEAD = 14;

/** Maximum total slots to request from the API */
export const DEFAULT_MAX_SLOTS = 100;

/** Date range limits */
export const MIN_DAYS_AHEAD = 1;
export const MAX_DAYS_AHEAD = 60;
